module.exports = __webpack_public_path__ + "img/circle-checkmark-confirm.0ea5bc34.svg";